exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-children{min-height:calc(100% - 60px);display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}._2vgDn{margin:20px;-ms-flex:1 1;flex:1 1}._2vgDn,.yU9KQ{background:#f5f5f5}.yU9KQ{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.jc-VV{background:#fff;width:220px;margin-right:10px}.jc-VV .ant-tree{background:#fff;padding:0 10px}._3Cp_M{-ms-flex:1 1;flex:1 1;margin-left:10px}._2A8go{overflow:hidden;margin-bottom:15px}._2A8go ._2MQiB{float:left}._2A8go ._1Pllg{float:right}._2A8go ._1Pllg button{margin-left:10px}._3tQDW{background:#fff}._3tQDW .ant-pagination{margin-right:15px}._2nDZG:hover,._2nDZG:link,._2nDZG:visited{color:#fff!important}._2nDZG:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"wrap": "_2vgDn",
	"row": "yU9KQ",
	"col": "jc-VV",
	"coltable": "_3Cp_M",
	"toolbar": "_2A8go",
	"toolbarLeft": "_2MQiB",
	"toolbarRight": "_1Pllg",
	"table": "_3tQDW",
	"tipLink": "_2nDZG"
};